import React from 'react';
import {
	withScriptjs,
	withGoogleMap,
	GoogleMap,
	Marker,
	Polyline,
	InfoWindow,
} from 'react-google-maps';
import { graphql, compose, Query, Mutation } from 'react-apollo';
import locationTempQueryClient from 'src/config/graphqlClient/query/locationTemp';
import updateLocationTempMutationClient from 'src/config/graphqlClient/mutation/updateLocationTemp';
import getNameFromlatlngQuery from './graphql/query/getNameFromlatlng';
import instancePriceStepQueryClient from 'src/config/graphqlClient/query/instancePriceStep';
import instancePriceQueryClient from 'src/config/graphqlClient/query/instancePrice';
import getMapPolylineQuery from './graphql/query/getMapPolyline';
import checkCountryQuery from './graphql/query/checkCountry';
import getProvinceQuery from './graphql/query/getProvince';
import polyline from '@mapbox/polyline';
import color from 'src/config/color';
import client from 'src/config/client';
import styled from 'styled-components';
import './style.css';
import { ModalConfirm } from 'src/components';
import _ from 'lodash';
import { withNamespaces } from "react-i18next";
import ReactHTMLParser from 'react-html-parser'; 
import DotDotDot from 'react-dotdotdot';
import googleMapsKey from 'src/config/googleMapsKey';
import { MarkerTime } from './components';
import moment from 'moment';
import 'moment-duration-format';
import { InstancePriceContext } from '../../contexts/InstancePriceContext';

const pinPickupIcon = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAA0CAYAAADi1poDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAppJREFUeNrMWEuOozAQJUn3ZKZXHMGLrLLiCByBIzA34AjcgHVWzA2YA0QikUaa7Mh+FuQEgdUsppuudo0cyQLb2MFu8qQnlA/2c1XZVWXPswfizYiIMqesKEHAhrKkTFwK9SlTNhkYEsWFti1yj5A+C7awScgtCOm7M5BNthhxUal6GbHZbC7b7bZdr9ctfm6aJtjv961G7Hyn/GFimUK2SkII7Ha75nq9NiDB6XSq4zges1agKyYVDeD7PmRZBiao6xrCMFS5bzSmApmYqqrgXiisVYwJKm2L0RAVGlmnKAqwARrwEASBkZUGWxz9bxNlWcqsJIyl2pV1eEisFIuS4yB2XAB3qkAQesdbqrI1XYmTpCgZl/QFDXxI48eJINW4y94Omx28oEP/x7ZtnUx6uVy0BA1wPp+dCFKNywsa/OtwODix0vF4FOrUOodMk6kO8DgRbPtIJCgTlRp45NtCmqZGWZ+IjnVMijaACVpindy4ZM3z3FVihbHqksgKejT3vZZRiMl0NkIsKzsx+5vURrgIiZuA9XXaXYiy24ii6L8bsUQVlRhJkqiE3ALZuIm03QJptUJjSCyLqWy017FFMb6tEz95JDFTY2pSzIyhukNQ5LKGIoY3IZn3CdCNp9pF3Gh3uCYdqZNaXeNy6tOh2nWzXIISiZh8zs4lfxTryGKpfIT+rlZdGsyBhEsR1jrXKbh1vT+9B0Jtw11PE617I953/6L8TbmmfGcE9tTGylDEgi0CJ/1K+Y3xhfIv5R/2G/KZjX+7nAfdCUyAk3xhfOaeT9zi3ihfOf7j2Nl02aLHJfdcsbGAc1MneMdqDAFbPe+Cjn235HbsO/c9b6nOhcv4gF4x8oHt9SzUcQHuuRSkGgemDPQhwAC3qLvGM4GyJgAAAABJRU5ErkJggg==`;
const pinDeliveryIcon = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAA0CAYAAADi1poDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4tJREFUeNrMWE1oE0EUnt02Fi2mSxE81J94UNCDNBfx1gjiwZMFoYpgE89CU+hBPajxoD0IRvBsW0G0ILQHTyI0vYh4SfCgoAejtYeCyDaxlZpk47zyFsfJzO7s7qz1wWPSMvP2m2++N/NmCNFgH/cfssB1xDJCfHyQNqPUoc1IupWoV6jPHPz8oRILIAokS5sb1FMB51ClXqDAprUAQkamkJEoBkzl/BgzFVgpawBDMEaZxsyHYogOBFayXoO7LKvaM3iUmL07YFmIs7ae2qi8JS3b9lvWacpUThkQzuKekNJkkvRdGLGT50dIYt9eYWY1vizZtSezZPXxrOXUajJQoKubvoAoGMicBVEE69Io6c9f3gSlYgDme/EBsR/OyLqcoKBKUkC4l5RFmbT77iTZeXY4lHjqz+bIysQVWQamKShbJuq8bjBgMBZiCCyF35Rm2ZhomaKAYUElxXHGhIAwxS1ewKAZXbbr+jWR/iz8dgdDQ3xPmJGqgFUMYklYGhIByoho1m2SmBkRoA4x9xw5rB2QJGbK9+jYfvwYicu8YpvM/vNf2CYgdmP6s8vWY/uoV2zpkm28ex8bIK/YJlev/GVrL15qByOJWREBKvG9avQM0m2SmCURoEXRbH6+fqMNDMSSMLQoO+0/8fsR7BsDTx9F3rGhFFk+d1GknypNqgMyURdEAvx263ZkdiCGRMwFvwJNWEP3njpJS4g7gZkCZlYmrkrFTNlJ+6U91Lq2SE9Lp88EyjyfMTZ+S6mmzuLVR2iJPQOkj9ZJcATwZxMsC4h3lZatja/LXnhzorua4XMFmoppb8zJLo6Gz70MyoI5vnCLYLBMw3xhH+bmuqABlI23jErkuz2CKkcElFZ5eDBVImGgXETNKL2CmKoRUYTFEGCKqi8fYd+Hgjw+dGx82hjiNs44+oYDhFooKHQtBH09C8sQQS3ZPikeRm/hAGENPu7RZVxUp8ciar/6ia9v/tWSSesnRX3FBmie05KN/9saQKgTFsB8WO3oYgjsvuT31hmIGwUe2bo1YSrpmlx3hKU2sDV/OM4r99ZEvQ21PeOxAurCMQlswc3n63X3iIAiroXeRG/g323dGyOA2cZ4gnF3Yi0GxC/0BtNqZcjg3ESQrruTc9jl5Ma0dQJqMbN0ddJEMCYDxmFYaiI7zTiWjBU0y47JxGEF7WopkLANTdnKxmlHCfRbgAEAE2xXcf+7pL4AAAAASUVORK5CYII=`;
const pinDeliveryIconRoundTrip = `data:image/png;base64,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`;

const GoogleMapsWrapper = withScriptjs(
	withGoogleMap(props => (
		<GoogleMap
			{...props}
			ref={c => {
				props.onMapMounted && props.onMapMounted(c);
			}}
		>
			{props.children}
		</GoogleMap>
	)),
);

const google = (window.google = window.google ? window.google : {});
const InfoConfirmContainer = styled.div`
	font-family: 'db_heavent';
	padding: 10px;
	width: 340px;

	& .title {
		font-size: 18px;
		font-weight: bold;
		line-height: 1.5;
	}

	& .sub-title {
		font-size: 18px;
		font-weight: bold;
	}

	@media(max-width: 767px) {
		width: 100%;
	}
`;

const ButtonConfirm = styled.button`
	width: 100%;
	background-color: ${props => (props.available ? '#d90101' : '#b3b3b3')};
	border-radius: 4px;
	border: 0px;
	outline: none;
	color: #ffffff;
	font-size: 18px;
	padding: 10px;
	font-weight: bold;

	&:hover {
		background-color: ${props => (props.available ? '#b70101' : '#C3C3C3')};
	}
`;

class GoogleMaps extends React.Component {
	state = {
		fitBounds: true,
		isCheckCountryAvailable: false,
		isLoadingCheckCountry: false,
		isOpenModal3Province: false,
		isOpenModalAlertFlashDeals: false,
		latLngBound: [],
		polylineList: [],
	};

	static contextType = InstancePriceContext;

	async componentWillReceiveProps(newProps) {
		if (!_.isEqual(newProps.instancePriceQuery.instancePrice.shipmentType, this.props.instancePriceQuery.instancePrice.shipmentType)) {
			console.log(newProps.instancePriceQuery.instancePrice.shipmentType)
			console.log(this.props.instancePriceQuery.instancePrice.shipmentType)
			this.setState({ latLngBound: [], polylineList: [] });
		}

		if (newProps.locationTempQuery.locationTemp.isFitBounds) {
			newProps.locationTempMutation({
				variables: {
					address: '',
					addressDefault: '',
					latitude: 0,
					longitude: 0,
					latitudeCenter: 0,
					longitudeCenter: 0,
					isFitBounds: false,
					isSelected: false,
					type: '',
					shipmentAddressIndex: 0,
					datetime: '',
				},
			});

			await this.getPolyline();
			this.setLatLngBound();
			this.setCenterAndZoom();
		}

		if (newProps.locationTempQuery.locationTemp.isSelected) {
			const { latitude, longitude } = newProps.locationTempQuery.locationTemp;
			const bounds = new window.google.maps.LatLngBounds();
			bounds.extend(new window.google.maps.LatLng(latitude, longitude));
			this._map.fitBounds(bounds);
			newProps.locationTempMutation({
				variables: {
					address: undefined,
					addressDefault: undefined,
					latitude: undefined,
					longitude: undefined,
					latitudeCenter: undefined,
					longitudeCenter: undefined,
					isFitBounds: undefined,
					isSelected: false,
					type: undefined,
					shipmentAddressIndex: undefined,
					datetime: undefined,
				},
			});
		}

		//เมื่อ address เปลี่ยน หรือกดเข้ามาเลือกตำแหน่ง ให้ตรวจสอบว่าตำแหน่งอยู่นอกพื้นที่บริการหรือไม่
		if(
			(!_.isEqual(newProps.locationTempQuery.locationTemp.latitude, this.props.locationTempQuery.locationTemp.latitude) ||
			!_.isEqual(newProps.locationTempQuery.locationTemp.longitude, this.props.locationTempQuery.locationTemp.longitude)) &&
			newProps.locationTempQuery.locationTemp.latitude !== 0 && newProps.locationTempQuery.locationTemp.longitude !== 0 //แก้ไขปัญหาบัคเมื่อเลือกลาก pin แล้วค้างกำลังโหลด...
		) {
			const { latitude, longitude, address } = newProps.locationTempQuery.locationTemp;
			this.setState({
				isLoadingCheckCountry: false,
				isCheckCountryAvailable: false,
			}, () => {
				this.onMarkerChanged(latitude, longitude, address);
			});
		}
	}

	async onMarkerChanged(lat, lng, address = '') {
		if(this.context.state.searchLocationIsDrag === true) {
			this.context.setData({
				searchLocationMainAddress: null,
				searchLocationSecondaryAddress: null,
				searchLocationContactName: '',
				searchLocationContactTel: '',
			});
		}

		if(this.context.state.searchLocationIsSelectContactAddress === false) {
			this.context.setData({
				searchLocationContactName: '',
				searchLocationContactTel: '',
			});
		}

		this.context.setData({
			searchLocationIsDrag: true,
			searchLocationIsSelectContactAddress: false,
		});

		client.writeQuery({
			query: locationTempQueryClient,
			data: {
				locationTemp: {
					...this.props.locationTempQuery.locationTemp,
					latitude: lat,
					longitude: lng,
				}
			}
		});

		try {
			this.setState({
				isLoadingCheckCountry: true,
				isCheckCountryAvailable: false,
			});

			const { data } = await client.query({
				query: getNameFromlatlngQuery,
				variables: {
					latitude: lat,
					longitude: lng,
				},
			});

			client.writeQuery({
				query: locationTempQueryClient,
				data: {
					locationTemp: {
						...this.props.locationTempQuery.locationTemp,
						address: address ? address : data.getNameFromlatlng.address || '',
						addressDefault: address ? address : data.getNameFromlatlng.address || '',
					}
				}
			});

			//check country
			const { data: checkCountryData } = await client.query({
				query: checkCountryQuery,
				variables: {
					latitude: lat,
					longitude: lng,
				}
			});

			this.setState({
				isLoadingCheckCountry: false,
				isCheckCountryAvailable: checkCountryData.checkCountry.available,
			});
		} catch(error) {
			console.log(error);
			this.setState({
				isLoadingCheckCountry: false,
				isCheckCountryAvailable: false,
			});
		}
	}

	getIcon(type) {
		if (type === 'pickup' || type === 'importPickup' || type === 'exportPickup') {
			return pinPickupIcon;
		} else {
			return pinDeliveryIcon;
		}
	}

	async fitBounds() {
		const {
			fitBounds,
		} = this.state;

		if(fitBounds === false) {
			return;
		}

		await this.getPolyline();
		this.setLatLngBound();
		this.setCenterAndZoom();
		this.setState({fitBounds: false});
	}

	setCenterAndZoom() {
		const {
			latLngBound
		} = this.state;

		const {
			shipmentAddress
		} = this.props.instancePriceQuery.instancePrice;

		const shipmentAddressFilter = shipmentAddress.filter(item => item.latitude !== 0 && item.longitude !== 0);
		if (shipmentAddressFilter.length < 2) {
			return;
		}

		const bounds = new window.google.maps.LatLngBounds();

		latLngBound.forEach((item) => {
			bounds.extend(
				new window.google.maps.LatLng(
					parseFloat(item.lat),
					parseFloat(item.lng),
				),
			);
		});

		bounds.extend(
			new window.google.maps.LatLng(
				this.getLatLngDefaultCenter().lat,
				this.getLatLngDefaultCenter().lng
			),
		);

		this._map.fitBounds(bounds);
	}

	setLatLngBound() {
		const {
			shipmentAddress,
		} = this.props.instancePriceQuery.instancePrice;

		const {
			polylineList
		} = this.state;

		const shipmentLatLng = shipmentAddress
			.filter(item => item.latitude !== 0 && item.longitude !== 0)
			.map((item) => {
				return {
					lat: item.latitude,
					lng: item.longitude,
				}
			});

		const polylineMarkerCenter = this.polylineDecode(polylineList)
			.filter(item => item.coordinates.length >= 2)
			.map((item, index) => {
				return {
					lat: this.getLatLngPolylineCenter(item.coordinates).lat,
					lng: this.getLatLngPolylineCenter(item.coordinates).lng,
				}
			});

		this.setState({
			latLngBound: [...shipmentLatLng, ...polylineMarkerCenter],
		});
	}

	getMarker() {
		const {
			createShipment,
			confirmShipment,
		} = this.props.instancePriceStepQuery.instancePriceStep;
		const {
			shipmentAddress,
			roundTrip,
		} = this.props.instancePriceQuery.instancePrice;
		const shipmentAddressFilter = shipmentAddress.map((item, index) => ({ ...item, index })).filter(item => item.latitude !== 0 && item.longitude !== 0);	

		if(createShipment || confirmShipment) {
			if (google.maps === undefined) {
				return shipmentAddress.map((item, index) => (
					<Marker
						key={index}
						icon={{
							url: this.getIcon(item.mode),
						}}

						position={{
							lat: parseFloat(item.latitude),
							lng: parseFloat(item.longitude),
						}}
					/>
				));
			}

			return shipmentAddressFilter.map((item, index) => {
				if(roundTrip && item.mode === 'delivery') {
					return (
						<Marker
							key={index}
							icon={{
								labelOrigin: new google.maps.Point(43, 64),
								url: pinDeliveryIconRoundTrip,
							}}
							position={{
								lat: parseFloat(item.latitude),
								lng: parseFloat(item.longitude),
							}}
							label={{
								color: '#000000',
								fontWeight: 'bold',
								fontSize: '14px',
								lineHeight: '20px',
								text: (item.index + 1).toString(),
							}}
						/>
					)
				}

				return (
					<Marker
						key={index}
						icon={{
							labelOrigin: new google.maps.Point(19, 16),
							url: this.getIcon(item.mode),
						}}
						position={{
							lat: parseFloat(item.latitude),
							lng: parseFloat(item.longitude),
						}}
						label={{
							color: '#000000',
							fontWeight: 'bold',
							fontSize: '14px',
							lineHeight: '20px',
							text: (item.index + 1).toString(),
						}}
					/>
				)
			});
		}

		return null;
	}
	
	onPolylineListFetched = (polylineList) => this.setState({ polylineList: polylineList });
	async fetchDataPolyline() {
		try {
			const instancePriceData = client.readQuery({
				query: instancePriceQueryClient,
			});
	
			const {
				shipmentAddress,
				roundTrip,
			} = instancePriceData.instancePrice;
	
			const shipmentAddressFilter = shipmentAddress.filter(item => item.latitude !== 0 && item.longitude !== 0);

			if(shipmentAddressFilter.length === 0) {
				return;
			}

			const { data } = await client.query({
				query: getMapPolylineQuery,
				variables: {
					address: shipmentAddressFilter.map(item => ({ lat: item.latitude, lng: item.longitude })),
					round_trip: roundTrip === 1 ? 1 : undefined,
				},
				fetchPolicy: 'network-only',
			});

			const {
				polyline_list: polylineList,
			} = data.getMapPolyline;

			this.onPolylineListFetched(polylineList);
		} catch(error) {
			console.log(error);
		}
	}

	async getPolyline() {
		this.setState({polylineList: []});
		await this.fetchDataPolyline();
	}

	renderPolyline() {
		const {
			polylineList
		} = this.state;

		const {
			createShipment,
			confirmShipment,
		} = this.props.instancePriceStepQuery.instancePriceStep;

		const {
			shipmentType,
		} = this.props.instancePriceQuery.instancePrice;

		if (createShipment || confirmShipment) {
			return (
				<React.Fragment>
					{shipmentType === 1 &&
						this.polylineDecode(polylineList)
							.filter(item => item.coordinates.length >= 2)
							.map((item, index) => (
								<MarkerTime
									key={index}
									title={this.getFormatTime(item.duration)}
									subTitle={`${this.props.t('common:googleMap.distance')} ${item.distance.toLocaleString('en-US', {maximumFractionDigits:2})} ${this.props.t('common:googleMap.km')}`}
									lat={this.getLatLngPolylineCenter(item.coordinates).lat}
									lng={this.getLatLngPolylineCenter(item.coordinates).lng}
								/>
						))}

					{this.polylineDecode(polylineList)
						.map((item, index) => (
							<Polyline
								key={index}
								options={{
									strokeColor: color.Blue,
									strokeWeight: 6,
								}}

								path={item.coordinates}
							/>
					))}
				</React.Fragment>
			);
		}

		return null;
	}

	getLatLngDefaultCenter() {
		return {
			lat: parseFloat(13.685702),
			lng: parseFloat(100.611084),
		};
	}

	polylineDecode(polylineListEncode) {
		const polylineListDecode = polylineListEncode.map((polylineEncode) => ({
			duration: polylineEncode.duration,
			distance: polylineEncode.distance,
			coordinates: polyline.decode(polylineEncode.polyline).map((point) => {
				return {
					lat: point[0],
					lng: point[1],
				};
			})
		}));

		return polylineListDecode;
	}

	getLatLngPolylineCenter(coordinates) {
		const coordinateCenterIndex = coordinates.length / 2 - 1;
		return {
			lat: coordinates[Math.floor(coordinateCenterIndex)].lat,
			lng: coordinates[Math.floor(coordinateCenterIndex)].lng,
		};
	}

	async onSubmit() {
		const {
			latitude,
			longitude,
		} = this.props.locationTempQuery.locationTemp;

		//get จังหวัดมาเพื่อใช้สำหรับตรวจสอบ 3 จังหวัดชายแดนภาคใต้
		const province = await this.getProvince(latitude, longitude);
		if(this.check3Province(province)) {
			this.setState({ isOpenModal3Province: true });
			return;
		}

		await this.updateShipmentAddress();
		this.checkPopupMultiDrop();
		this.closeSearchLocation();
	}

	async updateShipmentAddress() {
		const {
			type,
			addressDefault,
			latitude,
			longitude,
			shipmentAddressIndex,
		} = this.props.locationTempQuery.locationTemp;
		const { shipmentAddress } = this.props.instancePriceQuery.instancePrice;
		const province = await this.getProvince(latitude, longitude);
		const { searchLocationContactName, searchLocationContactTel } = this.context.state;
		
		//กรณียังไม่เคยมีตำแหน่ง
		if(shipmentAddress[shipmentAddressIndex] === undefined) {
			let newShipmentAddress = [...shipmentAddress];
			newShipmentAddress[shipmentAddressIndex] = {
				mode: type,
				address: addressDefault,
				latitude: Number(latitude),
				longitude: Number(longitude),
				contactName: searchLocationContactName || '',
				phoneNumber: searchLocationContactTel || '',
				remark: '',
				paidByCOD: null,
				province: province,
				pickupDate: '',
				isSaveContact: false,
				mainAddress: '',
				secondaryAddress: '',
				__typename: 'ShipmentAddress',
			}

			const resetPickupDateShipmentAddress = newShipmentAddress.map((item) => {
				return {
					...item,
					pickupDate: '',
				}
			});

			const instancePriceData = client.readQuery({
				query: instancePriceQueryClient,
			});

			client.writeQuery({
				query: instancePriceQueryClient,
				data: {
					instancePrice: {
						...instancePriceData.instancePrice,
						shipmentAddress: resetPickupDateShipmentAddress,
						optimizeRoute: false,
					}
				}
			});
		} else { //กรณีมีตำแหน่งอยู่แล้ว
			const { searchLocationMainAddress, searchLocationSecondaryAddress } = this.context.state;

			let contactData = {};
			if (
				!!searchLocationContactName &&
				!!searchLocationContactTel
			) {
				contactData = {
					contactName: searchLocationContactName,
					phoneNumber: searchLocationContactTel,
				};
			}

			const newShipmentAddress = shipmentAddress.map(
				(item, key) =>
					key === shipmentAddressIndex
						? {
								...item,
								...contactData,
								province: province,
								address: addressDefault,
								latitude: Number(latitude),
								longitude: Number(longitude),
								mainAddress: searchLocationMainAddress,
								secondaryAddress: searchLocationSecondaryAddress,
							}
						: item
			);

			const resetPickupDateShipmentAddress = newShipmentAddress.map((item) => {
				return {
					...item,
					pickupDate: '',
				}
			});

			const instancePriceData = client.readQuery({
				query: instancePriceQueryClient,
			});

			client.writeQuery({
				query: instancePriceQueryClient,
				data: {
					instancePrice: {
						...instancePriceData.instancePrice,
						shipmentAddress: resetPickupDateShipmentAddress,
						optimizeRoute: false,
					}
				}
			});
		}
	}

	async getProvince(lat, lng) {
		try {
			const { data: getProvinceData } = await client.query({
				query: getProvinceQuery,
				variables: {
					lat: String(lat),
					lng: String(lng),
				}
			});

			return getProvinceData.getProvince.province;
		} catch(error) {
			console.log(error);
		}
	}

	check3Province(province) {
		const provinces = ["ยะลา", "นราธิวาส", "ปัตตานี"];
		const index = provinces.indexOf(province)
		return index !== -1 ? true : false;
	}

	async handleAgree3Province() {
		//popup บริการรับส่งหลายจุด
		await this.updateShipmentAddress();
		this.checkPopupMultiDrop();
		this.setState({ isOpenModal3Province: false });
		this.closeSearchLocation();
	}

	checkPopupMultiDrop() {
		const {
			shipmentAddressIndex,
		} = this.props.locationTempQuery.locationTemp;
		const { shipmentAddress, shipmentType } = this.props.instancePriceQuery.instancePrice;
		//บริการรับส่งหลายจุด ให้ขึ้นข้อความรายละเอียด เมื่อเป็นการเพิ่มจุดที่ 3 เท่านั้น เมื่อเพิ่มจุดที่ 4 ขึ้นไปจะไม่ขึ้นอีก
		if(shipmentAddress.length < 4 && shipmentAddressIndex === 2 && shipmentType === 1 ) {
			const instancePriceStepData = client.readQuery({
				query: instancePriceStepQueryClient,
			});
			
			client.writeQuery({
				query: instancePriceStepQueryClient,
				data: {
					instancePriceStep: {
						...instancePriceStepData.instancePriceStep,
						notificationMultiDrop: true,
					}
				}
			});
		}
	}

	closeSearchLocation() {
		const instancePriceStepData = client.readQuery({
			query: instancePriceStepQueryClient,
		});

		client.writeQuery({
			query: instancePriceStepQueryClient,
			data: {
				instancePriceStep: {
					...instancePriceStepData.instancePriceStep,
					createShipment: true,
					searchLocation: false,
				},
			},
		});

		const locationTempData = client.readQuery({
			query: locationTempQueryClient,
		});

		client.writeQuery({
			query: locationTempQueryClient,
			data: {
				locationTemp: {
					...locationTempData.locationTemp,
					address: '',
					addressDefault: '',
					latitude: 0,
					longitude: 0,
					latitudeCenter: 0,
					longitudeCenter: 0,
					isFitBounds: true,
					isSelected: false,
					type: '',
					shipmentAddressIndex: 0,
					datetime: '',
				},
			},
		});
	}

	async checkFlashDealsProvince() {
		const {
			flashDeals,
		} = this.props.instancePriceQuery.instancePrice;

		if(!flashDeals.id) {
			return true;
		}

		const {
			latitude,
			longitude,
			shipmentAddressIndex,
		} = this.props.locationTempQuery.locationTemp;
		
		const province = await this.getProvince(latitude, longitude);

		if(
			(shipmentAddressIndex === 0 && flashDeals.locationStart.th === province) ||
			(shipmentAddressIndex === 1 && flashDeals.locationEnd.th === province)
		) {
			return true;
		} 

		return false;
	}

	clearFlashDeals() {
		const instancePriceData = client.readQuery({
			query: instancePriceQueryClient,
		});

		client.writeQuery({
			query: instancePriceQueryClient,
			data: {
				instancePrice: {
					...instancePriceData.instancePrice,
					flashDeals: {
						...instancePriceData.instancePrice.flashDeals,
						id: '',
					}
				}
			}
		});
	}

	getFormatTime(second) {
		return moment
			.duration(second, 'second')
			.format(`D [${this.props.t('common:instancePrice.totalDistance.time.day')}] H [${this.props.t('common:instancePrice.totalDistance.time.hour')}] m [${this.props.t('common:instancePrice.totalDistance.time.min')}]`, {
				trunc: true,
				trim: "both"
		});
	}

	getMarkerSelectLocation = () => {
		const locationTempData = client.readQuery({
			query: locationTempQueryClient,
		});

		const {
			latitude,
			longitude,
			type,
			addressDefault,
		} = locationTempData.locationTemp;

		const instancePriceStepData = client.readQuery({
			query: instancePriceStepQueryClient,
		});

		const {
			searchLocation,
		} = instancePriceStepData.instancePriceStep;


		if(latitude > 0 && longitude > 0) {
			return (
				<Marker
					icon={{
						url: this.getIcon(type),
					}}
					draggable={searchLocation &&
						( type === 'pickup' ||
							type === 'delivery' ||
							type === 'importDelivery' ||
							type === 'exportLoading' ||
							type === 'importReturn' ||
							type === 'exportPickup'
						)}
					onDragEnd={coords =>
						this.onMarkerChanged(coords.latLng.lat(), coords.latLng.lng())}
					position={{
						lat: latitude,
						lng: longitude,
					}}
				>
					<InfoWindow options={{headerDisabled: true}}>
						<InfoConfirmContainer>
							<div className="sub-title">
								<DotDotDot clamp={2}>
									{addressDefault}
								</DotDotDot>
							</div>
							<div style={{ marginTop: 10 }}>
								<ButtonConfirm
									className="search-location__confirm-location"
									available={
										this.state.isCheckCountryAvailable
									}
									disabled={
										!this.state.isCheckCountryAvailable || this.state.isLoadingCheckCountry
									}
									onClick={async () => {
										const isCheckFlashDealsProvince = await this.checkFlashDealsProvince();
										if(!isCheckFlashDealsProvince) {
											this.setState({
												isOpenModalAlertFlashDeals: true
											});
											
											return;
										}

										this.onSubmit();
									}}
								>
									{
										this.state.isLoadingCheckCountry ? this.props.t('common:instancePrice.searchLocation.loadingAddress') : this.state.isCheckCountryAvailable ? this.props.t('common:instancePrice.searchLocation.confirmAddress') : this.props.t('common:instancePrice.searchLocation.outsideTheServiceArea')
									}
								</ButtonConfirm>
							</div>
						</InfoConfirmContainer>
					</InfoWindow>
				</Marker>
			)
		}

		return null;
	}

	render() {
		return (
			<Query query={locationTempQueryClient}>
				{({ data }) => {
					return (
						<Mutation
							mutation={updateLocationTempMutationClient}
							refetchQueries={[
								{
									query: getNameFromlatlngQuery,
									variables: {
										latitude: data.locationTemp.latitudeCenter,
										longitude: data.locationTemp.longitudeCenter,
									},
								},
							]}
						>
							{updateLocationTemp => {
								return (
									<GoogleMapsWrapper
										clickableIcons={false}
										isMarkerShown
										loadingElement={<div style={{ height: `100%` }} />}
										containerElement={<div style={{ height: '100%' }} />}
										mapElement={<div style={{ height: `100%` }} />}
										googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${googleMapsKey}&v=3.exp&libraries=geometry,drawing,places`}
										zoom={15}
										defaultCenter={this.getLatLngDefaultCenter()}
										options={{
											mapTypeControl: false,
											panControl: false,
											streetViewControl: false,
											minZoom: 5,
											maxZoom: 20,
										}}
										onDragEnd={() => {
											updateLocationTemp({
												variables: {
													latitudeCenter: this._map.getCenter().lat(),
													longitudeCenter: this._map.getCenter().lng(),
												},
											})
										}}
										onIdle={() => {
											setTimeout(() => {
												this.fitBounds();
											}, 1000);
										}}
										onMapMounted={c => (this._map = c)}
									>
										{ this.getMarkerSelectLocation() }
										{ this.getMarker() }
										{ this.renderPolyline() }

										<ModalConfirm
											show={this.state.isOpenModal3Province}
											onPressButtonConfirm={() => this.handleAgree3Province()}
											onPressButtonCancel={() => this.setState({ isOpenModal3Province: false })}
											styleColorButtonConfirm="primary"
											labelButtonConfirm={this.props.t('common:instancePrice.notification.buttonConfirm')}
											labelButtonCancel={this.props.t('common:instancePrice.notification.buttonCancel')}
											titleHeader={this.props.t('common:instancePrice.notification.title')}
											onHide={() => this.setState({ isOpenModal3Province: false })}
										>
											<div style={{lineHeight: 1}}>
												{this.props.t('common:instancePrice.notification.detail').split('\n').map(item => (<div>{ReactHTMLParser(item)}</div>))}
											</div>
										</ModalConfirm>

										<ModalConfirm
											show={this.state.isOpenModalAlertFlashDeals}
											labelButtonConfirm={`ยืนยัน`}
											styleColorButtonConfirm="primary"
											labelButtonCancel={`ปิด`}
											titleHeader={`คุณกำลังพลาดโอกาส ได้ราคา FLASH DEALS !!`}
											onHide={() => {
												this.setState({
													isOpenModalAlertFlashDeals: false,
												});
											}}
											onPressButtonCancel={() => {
												this.setState({
													isOpenModalAlertFlashDeals: false,
												});
											}}
											onPressButtonConfirm={() => {
												this.clearFlashDeals();
												this.onSubmit();
												this.setState({
													isOpenModalAlertFlashDeals: false,
												});
											}}
										>
											<div style={{lineHeight: 1}}>
												คุณต้องการเลือกเขตพื้นที่นอกจังหวัดที่กำหนด ซึ่งจะส่งผลให้ไม่ตรงตามเงื่อนไขของ FLASH  DEALS ยืนยันทำรายการนี้ต่อหรือไม่
											</div>
										</ModalConfirm>
									</GoogleMapsWrapper>
								);
							}}
						</Mutation>
					);
				}}
			</Query>
		);
	}
}

export default compose(
	graphql(instancePriceQueryClient, {
		name: 'instancePriceQuery',
	}),
	graphql(instancePriceStepQueryClient, {
		name: 'instancePriceStepQuery',
	}),
	graphql(locationTempQueryClient, {
		name: 'locationTempQuery',
	}),
	graphql(updateLocationTempMutationClient, {
		name: 'locationTempMutation',
	}),
)(withNamespaces()(GoogleMaps));
